import styled, {useTheme} from "styled-components";
import {useTranslation} from "react-i18next";
import React, {useMemo} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Pagination} from "swiper/modules";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import {useHistory} from "react-router-dom";

const Wrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;

    & + & {
        margin-left: 26px;
    }
`;
const TitleBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
`;

const Title = styled.div`
    display: flex;
    flex-direction: row;
`;

const GreenTitle = styled.span`
    color: ${props => props.theme.color.green_100};
    font-size: 20px;
    font-weight: bold;
    margin-right: 8px;
`;

const BlackTitle = styled.span`
    color: ${props => props.theme.color.dark_100};
    font-size: 20px;
    font-weight: bold;
`;

const ExtraWrapper = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
const ExtraText = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${props => props.theme.color.dark_200};
    margin-right: 2px;

    &:hover {
        text-decoration: underline;
    }
`;
const ContentBox = styled.div`
    width: 577px;
    height: 100%;
    border: 1px solid ${props => props.theme.color.default_border_color};
    background-color: ${props => props.theme.color.site_main_color};
    border-radius: 10px;
    padding: 15px;
`;
const SplitLine = styled.div`
    height: 1px;
    background-color: ${props => props.theme.color.gray_200};
    width: 100%;
    margin: 8px 0;
`;
const HomeEventNotice = ({title, list, onClickMore}) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const listMemo = useMemo(() => {
        try {
            if (Array.isArray(list)) {
                return list;
            }
            return [];
        } catch (e) {
            return [];
        }
    }, [list]);

    return (
        <Wrapper>
            <TitleBox>
                <Title>
                    <GreenTitle>{title}</GreenTitle>
                    <BlackTitle>EVENT</BlackTitle>
                </Title>
            </TitleBox>
            <ContentBox>
                <HomeSwiper/>
            </ContentBox>
        </Wrapper>
    );
};

const SwiperCss = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    .swiper {
        width: 100%;
        height: 100%;
    }
    
    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #444;

        /* Center slide text vertically */
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        text-align: center;
        line-height: 20px;
        font-size: 12px;
        color: #000;
        opacity: 1;
        background-color: ${props => props.theme.color.dark_300};
        transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s;
        border-radius: 8px;
    }

    .swiper-pagination-bullet-active {
        border-radius: 8px;
        width: 24px;
        height: 8px;
        background-color: ${props => props.theme.color.green_100};
    }
`;

const HomeSwiper = () => {
    const history = useHistory();
    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
        },
    };
    const handleContentClick = (swiper) => {
        // 실제로 클릭된 HTML 요소를 가져옵니다.

        // 클릭된 슬라이드의 인덱스 번호 (loop 모드일 땐 realIndex 사용)
        const realIndex = swiper.realIndex;

        switch (realIndex) {
            case 0: history.push(`/connect`)
                break
            case 1: history.push(`/llm`)
                break
            case 2: history.push('/event')
                break
        }
    };
    return (
        <SwiperCss>

            <Swiper
                pagination={pagination}
                modules={[Autoplay,Pagination]}
                autoplay={{
                    delay: 3000, // 3초마다 슬라이드 넘김 (기본값: 3000)
                    disableOnInteraction: false, // 유저가 터치/드래그해도 자동 재생이 멈추지 않도록 설정
                    pauseOnMouseEnter: true, // 마우스를 올리면 자동 재생 일시정지 (유저 친화적 옵션)
                }}
                className="mySwiper"
                loop={true}
                onClick={handleContentClick}
            >
                <SwiperSlide style={{  height: '278px', display: 'flex', justifyContent: 'center', alignItems: 'center',cursor:'pointer' }}>
                        <img src={'./images/rolling/rolling_banner_connect.png'} width={'100%'} height={'100%'} alt={''}/>
                </SwiperSlide>
                <SwiperSlide style={{  height: '278px', display: 'flex', justifyContent: 'center', alignItems: 'center',cursor:'pointer' }}>
                    <img src={'./images/rolling/rolling_banner_ai.png'} width={'100%'} height={'100%'} alt={''}/>
                </SwiperSlide>
                <SwiperSlide style={{  height: '278px', display: 'flex', justifyContent: 'center', alignItems: 'center',cursor:'pointer' }}>
                    <img src={'./images/rolling/rolling_banner_event.png'} width={'100%'} height={'100%'} alt={''}/>
                </SwiperSlide>
            </Swiper>

        </SwiperCss>
    )
}


export default HomeEventNotice;